import { render, staticRenderFns } from "./CharacterDetails.vue?vue&type=template&id=55a6d378&"
import script from "./CharacterDetails.vue?vue&type=script&lang=js&"
export * from "./CharacterDetails.vue?vue&type=script&lang=js&"
import style0 from "./CharacterDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports